module.exports = __webpack_public_path__ + "static/media/rotate-to-portrait.c959de3f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/rotate-to-portrait.gif
// module id = 652
// module chunks = 0